import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'

import { SearchAnalyticsPage } from '@/components/Ams/SearchAnalyticsPage'
import { searchAnalyticsSearchSchema, pruned } from '@/components/Ams/search'
import { EMPTY_PRIMARY_FILTERS } from '@/lib/filters'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/keyword-performance/')({
  validateSearch: searchAnalyticsSearchSchema,
  // A link to this page carries no defaults: the clean URL is the default view.
  search: { middlewares: [stripSearchParams(EMPTY_PRIMARY_FILTERS)] },
  component: KeywordPerformanceRoute,
})

function KeywordPerformanceRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SearchAnalyticsPage
      search={search}
      onSearchChange={(next) =>
        void navigate({ search: (current) => pruned({ ...current, ...next }), replace: true })
      }
    />
  )
}
